import { useCardMenuStore } from '@cockpitai/store/cardMenu'
import { CreateAlertFlow } from './modules/CreateAlertFlow'
import { ModalConfirm } from '../MenuCard/modules/Delete/ModalConfirm'

export function MenuCardModules() {
  const { current } = useCardMenuStore()

  return (
    <>
      {current === 'create-alert' && <CreateAlertFlow />}
      {current === 'delete-panel' && <ModalConfirm />}
    </>
  )
}
